/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import { Button, Col, Label, Modal, ModalBody, ModalFooter, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './customModal.css';
import SpinnerCircles from './Spinner/SpinerCircles';

const CustomWarning = ({
  isOpen,
  onCancel,
  onConfirm,
  bodyText,
  children,
  boldText,
  isIntegratedBox,
  disabled,
  customText,
  loading,
  customCancelText
}) => {
  const normalizedBodyText = useMemo(() => {
    let data = bodyText;
    if (bodyText?.includes(`${boldText}`)) {
      data = bodyText.replace(`${boldText}`, `<b style='font-size:20px'>${boldText}</b><br/>`);
    }
    return data;
  }, [boldText, isIntegratedBox, disabled]);

  const sanitizeData = () => {
    return {
      __html: normalizedBodyText,
    };
  };
  return (
    <Modal isOpen={isOpen} centered className={isIntegratedBox ? 'custom-warning-modal' : ''}>
      <ModalBody>
        <Row>
          {!isIntegratedBox ? (
            <Col lg={2} md={2} sm={6}>
              <div className="delete-box-icon">
                <FontAwesomeIcon
                  style={{ width: '40px', height: '40px' }}
                  icon="exclamation-triangle"
                  color="#F30106"
                />
              </div>
            </Col>
          ) : (
            ''
          )}
          <Col lg={!isIntegratedBox ? 10 : 12} md={!isIntegratedBox ? 10 : 12} sm={6}>
            {!isIntegratedBox ? (
              <p className="text-style" dangerouslySetInnerHTML={sanitizeData()} />
            ) : (
              ''
            )}
            {children}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {onCancel && <Button color="danger" onClick={onCancel} disabled={loading}>
          {customCancelText || 'Cancel'}
        </Button>}
        <Button disabled={loading || disabled} color="primary" onClick={onConfirm}>
          {loading ? <SpinnerCircles /> : customText || (!isIntegratedBox ? 'Proceed' : 'Execute')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CustomWarning;
